import Vue from "vue";
import App from "./app.vue";
import router from "./router";
import store from "./store";
import "./filters";
import Notifications from "vue-notification";
import QModal from "@/common/plugins/modal";
import messages from "@/i18n";
import VueI18n from "vue-i18n";
import LogRocket from 'logrocket';

Vue.use(VueI18n);
Vue.use(Notifications);
Vue.use(QModal);

Vue.config.productionTip = false;
const trans18next = new VueI18n({
  locale: "ja",
  messages,
});

if (process.env.NODE_ENV === "production" && process.env.VUE_APP_LOG_ROCKET_ID) {
  LogRocket.init(process.env.VUE_APP_LOG_ROCKET_ID)
}

const vueApp = new Vue({
  router,
  i18n: trans18next,
  store,
  render: (h) => h(App),
}).$mount("#app");

export default vueApp;
